import { useContext } from 'react';
import { PdfContext } from 'utils/context';
import CultureListTable from '../Tables/CultureListTable';
import { useTranslation } from 'react-i18next';

const CultureListOrganic = () => {
  const { t } = useTranslation();
  const { cultures } = useContext(PdfContext);

  const numberOfRowPerTable = 10;
  let slicedCultureTable = [];

  const organicCultures = cultures.filter((cultures) => cultures.isOrganic);
  for (let i = 0; i < organicCultures.length; i += numberOfRowPerTable) {
    slicedCultureTable.push(organicCultures.slice(i, i + numberOfRowPerTable));
  }

  return (
    <div>
      {slicedCultureTable.map((data, index) => (
        <CultureListTable
          key={index}
          truncatedCultures={data}
          messageDuplicate={index > 0 ? t('simulation.common.continued') : ''}
          isOrganic={true}
        />
      ))}
    </div>
  );
};

export default CultureListOrganic;
